import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "dvBodyTree scroll-thin-custom" }
const _hoisted_2 = { class: "p-treenode-content" }
const _hoisted_3 = {
  key: 0,
  class: "p-treenode-label"
}
const _hoisted_4 = {
  class: "p-treenode-content",
  style: {"margin-left":"-15px"}
}
const _hoisted_5 = { class: "p-treenode-icon" }
const _hoisted_6 = {
  key: 0,
  class: "p-treenode-label"
}

import { useServicesFactoryStore } from '@/core/stores/services-factory-store';
import Tree from 'primevue/tree';
import { PropType, computed } from 'vue';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { TreeNode } from 'primevue/treenode';
import AppUIManagerService from '@/core/services/AppUIManagerService';
import { useRouter } from 'vue-router';


export default /*@__PURE__*/_defineComponent({
  __name: 'MenuVComponent',
  props: {
 go: Boolean,
 menus: { type: Array as PropType<any>, required:true },
 smallMode:Boolean
},
  emits: ['onClickMenu'],
  setup(__props, { emit: __emit }) {

const props = __props;
const emit = __emit;
const router = useRouter();
const uiManager:AppUIManagerService = useServicesFactoryStore().getAppUIManagerService;
const menuFilter = computed(()=>
{
    const filteredMenus = new Array<any>();
    if(props.menus && props.menus.length > 0)
    {
        for (const menu of props.menus)
        {
          filteredMenus.push(menu);
        }
    }
    return filteredMenus;
});
const onNodeSelect= (node : TreeNode) =>
{    
    uiManager.ReloadCurrentAction = null;
    if(node &&  node.data && node.data.url)
    {
        if(props.go)
        {            
            router.replace({ name: node.data.url });
        }
        uiManager.ActiveMenu.next(node);
        emit('onClickMenu',node);
    }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(Tree), {
      value: menuFilter.value,
      selectionMode: "single",
      onNodeSelect: onNodeSelect
    }, {
      default: _withCtx((slotProps) => [
        _createElementVNode("div", _hoisted_2, [
          (!__props.smallMode)
            ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(_ctx.$t(`menus.menu_${slotProps.node.label}`)), 1))
            : _createCommentVNode("", true)
        ])
      ]),
      fontawesome: _withCtx((slotProps) => [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("span", _hoisted_5, [
            _createVNode(_unref(FontAwesomeIcon), {
              icon: slotProps.node.icon.split(' ')
            }, null, 8, ["icon"])
          ]),
          (!__props.smallMode)
            ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(_ctx.$t(`menus.menu_${slotProps.node.label}`)), 1))
            : _createCommentVNode("", true)
        ])
      ]),
      _: 1
    }, 8, ["value"])
  ]))
}
}

})